import { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import PayoutControl from "@/components/PayoutControl";
import { api, fmtNGN, fmtDate } from "@/lib/api";
import { CircleNotch, GraduationCap } from "@phosphor-icons/react";

export default function AdminALAPayouts() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/ala/payouts").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  return (
    <DashboardShell title="ALA payouts" subtitle="Academic Liquidity Advances with an active salary mandate, ready to pay to the staff member's salary account.">
      {rows === null ? (
        <div className="card text-center py-10"><CircleNotch size={28} className="animate-spin mx-auto text-[#0A3622]" /></div>
      ) : rows.length === 0 ? (
        <div className="card text-sm text-[#4F5D4F]" data-testid="ala-payouts-empty">No advances are waiting for payout.</div>
      ) : (
        <div className="space-y-4" data-testid="ala-payouts-list">
          {rows.map((a) => <PayoutRow key={a.id} a={a} onDone={load} />)}
        </div>
      )}
    </DashboardShell>
  );
}

function PayoutRow({ a, onDone }) {
  const acct = a.bank_account || {};
  const sample = acct.provider !== "mono" || a.mandate_provider !== "remita";
  return (
    <div className="card grid lg:grid-cols-12 gap-4 items-start" data-testid={`ala-payout-${a.id}`}>
      <div className="lg:col-span-5">
        <div className="flex items-center gap-2 font-display font-medium text-[#132A13]"><GraduationCap size={16} weight="fill" /> {a.applicant_name || a.applicant_email}</div>
        <div className="text-xs text-[#4F5D4F] mt-1">{a.institution} · {a.applicant_email}</div>
        <div className="text-xs text-[#4F5D4F] mt-1">Mandate {a.mandate_reference || "—"} ({a.mandate_provider || "—"}) · active {fmtDate(a.mandate_active_at)}</div>
      </div>
      <div className="lg:col-span-3 text-sm">
        <div className="font-display font-medium" data-testid={`ala-payout-amount-${a.id}`}>{fmtNGN(a.principal)}</div>
        <div className="text-xs text-[#4F5D4F]">{a.tenor_days} days · {fmtNGN(a.monthly_installment)}/mo</div>
        <div className="text-xs text-[#4F5D4F] mt-1">To {acct.bank_name} · <span className="font-mono">{acct.account_number}</span></div>
      </div>
      <div className="lg:col-span-4">
        {a.state === "disbursed" ? (
          <div className="text-xs text-[#2D7A5D]" data-testid={`ala-payout-done-${a.id}`}>
            Sent {fmtDate(a.disbursed_at)} · Paystack <span className="font-mono">{a.payout?.transfer_code}</span> · {a.payout?.status}
          </div>
        ) : sample ? (
          <p className="text-xs text-[#B45309]" data-testid={`ala-payout-sample-${a.id}`}>
            Can't pay out yet: {acct.provider !== "mono" ? "the salary account was linked with sample data (Mono not connected)" : "the salary mandate is simulated (Remita not connected)"}.
          </p>
        ) : (
          <PayoutControl payout={a.payout} amountLabel={fmtNGN(a.principal)} testid={`ala-disburse-${a.id}`} retryNote="The advance is still waiting for payout, so you can retry."
            disbursePath={`/admin/ala/${a.id}/disburse`} otpPath={`/admin/ala/${a.id}/disburse/otp`} onDone={onDone} />
        )}
      </div>
    </div>
  );
}
